export default __webpack_public_path__ + "assets/webgl/scene-11.68578523.glb";